import React, { useEffect, useState } from "react";
import { Backdrop, Button, FormFieldSet, LogoLoader, showToast, useFormHandler } from "../../../../components";
import { updateLeadContact } from "../../../../redux/slices/bdmjobs/bdmjobsApi";

const EditContactModal = ({ data, onCancel, onSuccess }) => {
    const [loading, setLoading] = useState(false);
    const validationRules = {
        firstName: {
            type: "text",
            required: true,
        },
        email: {
            type: "text",
            required: true,
        },
        designation: {
            type: "text",
            required: true,
        },
    };

    const initialFormData = {
        firstName: "",
        lastName: "",
        website: "",
        email: "",
        source: "",
        phone: {
            code: "",
            number: ""
        },
        status: "",
        designation: "",
        url: "",
    };

    const { formData, errors, handleChange, validateAllFields, setFormData } =
        useFormHandler(initialFormData, validationRules);

    const handleSubmit = async () => {
        const isValid = validateAllFields();
        if (!isValid) return;
        const payload = [
            {
                type: "SET",
                value: {
                    firstName: formData.firstName,
                    lastName: formData.lastName,
                    email: formData.email,
                    source: formData.source,
                    designation: formData.designation,
                    websiteUrl: formData.website,
                    url: formData.url,
                    mobile: {
                        code: formData.phone.code,
                        number: formData.phone.number,
                    },
                    emailStatus: formData.status,
                },
            },
        ];

        try {
            setLoading(true);
            const res = await updateLeadContact({
                coll: "LeadContact",
                uiid: data?.uiid,
                payload,
            });
            if (res?.data) {
                showToast("Contact updated successfully", "success");
                onSuccess?.();
            }
        } catch (err) {
            console.error("Update contact failed", err);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        if (!data) return;
        setFormData({
            firstName: data?.firstName || "",
            lastName: data?.lastName || "",
            email: data?.email || "",
            source: data?.source || "",
            designation: data?.designation || "",
            website: data?.websiteUrl || "",
            url: data?.url || "",
            phone: {
                code: data?.mobile?.code || "",
                number: data?.mobile?.number || "",
            },
            status: data?.emailStatus || "",
        });
    }, [data]);


    return (
        <div className="flex flex-col gap-5 p-4 sm:p-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
                <FormFieldSet
                    type="text"
                    title="First Name"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.firstName}
                    onChange={(value) => handleChange("firstName", value)}
                    error={errors.firstName}
                />

                <FormFieldSet
                    type="text"
                    title="Last Name"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.lastName}
                    onChange={(value) => handleChange("lastName", value)}
                    error={errors.lastName}
                />

                <FormFieldSet
                    type="text"
                    title="Designation"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.designation}
                    onChange={(value) => handleChange("designation", value)}
                    error={errors.designation}
                    className="sm:col-span-2 lg:col-span-1"
                />

                <FormFieldSet
                    type="text"
                    title="URL"
                    shadow={true}
                    placeholder="Enter"
                    value={formData.url}
                    onChange={(value) => handleChange("url", value)}
                    error={errors.url}
                />

                <FormFieldSet
                    type="text"
                    title="Website URL"
                    shadow={true}
                    placeholder="Enter"
                    value={formData.website}
                    onChange={(value) => handleChange("website", value)}
                    error={errors.website}
                />

                <FormFieldSet
                    type="text"
                    title="Email"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.email}
                    onChange={(value) => handleChange("email", value)}
                    error={errors.email}
                />

                <FormFieldSet
                    type="phone"
                    title="Phone"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.phone?.number || ""}
                    code={formData.phone?.code || ""}
                    onChange={(fullValue, details) =>
                        handleChange(`phone`, {
                            code: details.countryCode,
                            number: details.number,
                        })
                    }
                    error={errors.phone}
                />

                <FormFieldSet
                    type="text"
                    title="Source"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.source}
                    onChange={(value) => handleChange("source", value)}
                    error={errors.source}
                />

                <FormFieldSet
                    type="text"
                    title="Status"
                    size="md"
                    placeholder="Enter"
                    value={formData?.status}
                    onChange={(value) => handleChange("status", value)}
                    error={errors.status}
                />
            </div>

            <div className="flex flex-col-reverse sm:flex-row justify-end items-center gap-3 mt-2">
                <Button
                    variant="outlined"
                    title="Cancel"
                    color="black"
                    onClick={() => onCancel()}
                    className="w-full sm:w-auto"
                />
                <Button
                    title="Save"
                    variant="contained"
                    color="primary"
                    className="w-full sm:w-auto"
                    onClick={() => handleSubmit()}
                    disabled={loading}
                />
            </div>
            <Backdrop isOpen={loading}>
                <LogoLoader />
            </Backdrop>
        </div>
    );
};

export default EditContactModal;